import styled from '@emotion/styled';
import { globalVariables } from '../../../shared/designSystem/constants';
import { useDetermineMobile } from '@myrealtrip/device-detect';

export default function Copyright() {
  const isMobile = useDetermineMobile();

  return (
    <Container>
      <Text>
        <span>
          {
            '상호명 (주)마이리얼트립 | 대표 이동건 | 개인정보보호책임자 김형석 | 사업자등록번호 209-81-55339 '
          }
        </span>
        <span>
          <a target="_blank" href="https://www.ftc.go.kr/bizCommPop.do?wrkr_no=2098155339">
            {'사업자정보확인'}
          </a>
        </span>
        <span>{' | 통신판매업신고번호 2019-서울서초-0260 | 관광사업등록번호 : 제2019-3호'}</span>
        <br />
        {isMobile && (
          <>
            <span>
              {
                '주소 서울특별시 서초구 강남대로 311, 18층 1729호(서초동, 한화생명보험빌딩) | 이메일 help@myrealtrip.com | 마케팅 문의 marketing@myrealtrip.com | 제휴 문의 partnership@myrealtrip.com | 호스팅 서비스 제공자 : (주)마이리얼트립'
              }
            </span>
          </>
        )}
        {!isMobile && (
          <>
            <span>
              {'주소 서울특별시 서초구 강남대로 311, 18층 1729호(서초동, 한화생명보험빌딩)'}
            </span>
            <br />
            <span>{'이메일 help@myrealtrip.com | 입점 문의 partnership@myrealtrip.com'}</span>
            <br />
            <span>
              {
                '마케팅파트너/크리에이터 문의 marketing_partner@myrealtrip.com | 마케팅 문의 marketing@myrealtrip.com | 호스팅 서비스 제공자 : (주)마이리얼트립'
              }
            </span>
          </>
        )}
        <br />
        <br />
        <span>{'자사는 서울특별시관광협회 공제영업보증보험에 가입되어 있습니다. '}</span>
        {isMobile && <br />}
        <span>{'영업보증보험: 1.5억원 / 기획여행보증: 2억원'}</span>
        <br />
        <span>
          {
            '마이리얼트립은 통신판매중개자이며 통신판매의 당사자가 아닙니다. 따라서 상품·거래정보 및 거래에 대하여 책임을 지지않습니다.'
          }
        </span>
        <br />
        <span>
          {'부득이한 사정에 의해 확정된 여행일정이 변경되는 경우 여행자의 사전 동의를 받습니다.'}
        </span>
        <br />
        <br />
        <span>
          {
            '(주)마이리얼트립이 소유, 운영, 관리하는 웹사이트 및 앱 내의 상품, 판매자 정보, 이벤트 정보, 디자인, UI 등을 포함한 일체의 콘텐츠에 대한 무단 복제, 배포, 전송, 스크래핑 등의 행위는 저작권법 등 관련 법령에 의하여 엄격히 금지됩니다.'
          }
        </span>
      </Text>
    </Container>
  );
}

const Container = styled.div`
  margin-top: 16px;
`;

const Text = styled.p`
  font-size: 12px;
  letter-spacing: -0.2px;
  color: ${globalVariables.gray_500};
  line-height: 18px;

  a {
    font-weight: 500;
    color: ${globalVariables.gray_600};
  }
  > span {
    letter-spacing: -0.2px;
    line-height: 18px;
  }
`;
